import React, {useCallback, useEffect, useState} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import { useUser } from "../../contexts/UserContext";
import {getReports, sendMsg} from "../../services/ReportService";
import styles from '../Report/Report.module.css';
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useModal} from "../../contexts/ModalContext";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";


function ReportPage({ title }) {
    const { user } = useUser();
    const { id } = useParams();
    const [reports, setReports] = useState('');
    const { showModal } = useModal();
    const [utilisateur, setUtilisateur] = useState('');
    const navigate = useNavigate();

    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 2000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 2000 });
    }, [showModal]);

    useEffect(() => {
        if (!id) return;
        let userId = +id;
        if (id === "me") {
            userId = user.id;
        }
        async function fetchReports() {
            try {
                const result = await getReports(+userId);
                if (result.success) {
                    setReports(result.data);
                    setUtilisateur(result.utilisateur);
                } else {
                    handleError(result.message);
                    navigate(Routing.routes.unauthorized);
                }
            } catch (error) {
                handleError("Erreur lors de la récupération des reports:", error);
                console.error("Erreur lors de la récupération des reports:", error);
            }
        }

        fetchReports();
    }, [id]);


    return (
        <div className="content">
            <TitleMain text={title}/>

            <div style={{ width: "100%" }}>
                {/*
                <p style={{ textTransform: "uppercase", fontWeight: 500 }}>{utilisateur}</p>
                */}

                <ul style={{ padding: 0}}>
                    {reports.length > 0 ? reports.map((report, index) => (
                        <li key={index} className={styles.liste}>
                            {/*
                            <div className={styles.controls}>
                                <button title={"Résolu"}><FontAwesomeIcon icon={faCheck} /></button>
                            </div>
                            */}

                            <span style={{ fontSize: "0.9rem" }}>{DateService.formatDate(report.createdAt)} {report.updatedAt ? " (mis à jour " + DateService.formatDate(report.updatedAt) + ")" : null}</span>

                            {report.concern ?
                                <div>
                                    <span>
                                        Objet du signalement :
                                        <Link to={report.from}>{report.from}</Link>
                                    </span>
                                </div>
                                : null}
                            <span>Message: <p style={{fontWeight: 600 }}>{report.message}</p></span>
                        </li>
                    )) : <li><p style={{ textAlign: "center" }}>Pas de signalements enregistrés</p></li>}
                </ul>
            </div>
        </div>
    )
}

export default ReportPage;
